import { GetAllRetailers_allRetailers_edges_node_priceStocks_edges_node } from '@src/app/generated/GetAllRetailers';
import { SKU, sku } from '@src/app/model/sku';
import { Id, id as idConstructor } from '@ess/jg-rule-executor/dist/src/domain/id';
import { ItemPriceStock, PriceStockData, WoodPriceStock } from '@src/app/model/price-stock-data';
import { ToJsonInputTranslatable } from '@src/app/model/to-json-input-translatable';
import { SinglePriceStockInput, WoodPriceStockInput } from '@src/app/generated/globalTypes';

export class PriceStock implements ToJsonInputTranslatable {
  id: Id<PriceStock>;
  sku: SKU;
  data: PriceStockData;

  constructor(id?: any, skuInput?: SKU, data?: PriceStockData) {
    this.id = id;
    this.sku = skuInput;
    this.data = data;
  }

  static fromGql(gql: GetAllRetailers_allRetailers_edges_node_priceStocks_edges_node): PriceStock {
    return new PriceStock(
      gql.id,
      sku(gql.sku),
      PriceStockData.fromGql(gql.data)
    );
  }

  toGqlInput(): SinglePriceStockInput | WoodPriceStockInput {
    if (this.data instanceof ItemPriceStock) {
      return {
        sku: this.sku as unknown as string,
        data: this.data.toGqlInput(),
      };
    } else if (this.data instanceof WoodPriceStock) {
      return {
        sku: this.sku as unknown as string,
        prices: this.data.toGqlInput(),
      };
    }
    return;
  }

  static defaultSingle: PriceStock = new PriceStock(
    idConstructor('id which will be ignored'),
    sku('SKU'),
    ItemPriceStock.defaultValue
  );

  static defaultWood: PriceStock = new PriceStock(
    idConstructor('id which will be ignored'),
    sku('SKU'),
    WoodPriceStock.defaultValue
  );
}
